import { createFileRoute } from '@tanstack/react-router'
import { QrSchedulesScreen } from '@/components/schedules/qr-schedules-screen'
import { SchedulesSkeleton } from '@/components/shell/screen-skeletons'

/**
 * Its own pending component, rather than inheriting the control panel's.
 *
 * Under the App Router a `loading.tsx` covered its segment's child routes too,
 * so this tab wore the QR preview, the scan tiles and the destination grid on
 * the way in — a different screen entirely. Pending components are per-route,
 * so that cannot happen here; naming it is now just accuracy rather than a fix.
 */
export const Route = createFileRoute('/o/$org/qr-codes/$id/schedules')({
  pendingComponent: SchedulesSkeleton,
  component: QrSchedulesRoute,
})

function QrSchedulesRoute() {
  const { id } = Route.useParams()
  return <QrSchedulesScreen constellationId={id} />
}
